<template lang="html">
    <ul class="searchBox">
        <li class="li">
            <span class="li-left">车辆型号</span>
            <span class="li-right">{{ model_name }}</span>
        </li>
        <li class="li">
            <span class="li-left">行驶公里数</span>
            <span class="li-right"><i class="km">{{ drive_mileage }}</i>KM</span>
        </li>
    </ul>
</template>
<script>
export default {
    name: 'searchBox',
    props: {
        /* 车辆型号 */
        model_name:{
            type: String,
            default: function () {
                return ''
            }
        },
        /* 公里数 */
        drive_mileage:{
            type: Number,
            default: function () {
                return 0
            }
        }
    },
    components: {
    },
    data () {
        return {
        }
    }
}
</script>

<style lang="stylus" scoped>
@import '~@/assets/stylus/variables.styl'
@import '~@/assets/stylus/mixin.styl'
.searchBox
    margin 30px 30px 0 30px
    border-radius 16px
    border 1px solid #fc2d2d
    background #fff
    padding 0 30px
    line-height 0
    .li
        height 100px
        line-height 100px
        font-size 28px
        display flex
        .li-left
            color #666666
            font-size 28px
            margin-right 20px
        .li-right
            flex 1
            color #3b3b3b
            text-align right
            textOverflow()
            padding-right 60px
            .km
                margin-right 70px
                color #ff6600
                font-style normal
    li:first-child
        border-bottom 1px solid #efefef
</style>
